import { render } from "./ColumnChooser.vue?vue&type=template&id=70d18b76&scoped=true"
import script from "./ColumnChooser.vue?vue&type=script&lang=js"
export * from "./ColumnChooser.vue?vue&type=script&lang=js"

import "./ColumnChooser.vue?vue&type=style&index=0&id=70d18b76&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d18b76"]])

export default __exports__